import { ReactNode, useState, Children, useEffect, useCallback, useRef } from 'react';
import { Button, ButtonSizeXL } from '@picsart/button';

import SeeAllFonts from '../../SeeAllFonts';
import { useStore } from '../../../store';
import analytics from '../../../services/analytics';
import getPositionOffset from '../../../utils/common/getPositionOffset';
import getFontId from '../../../utils/common/getFontId';

import useStyles from './styles';

type LoadMoreProps = {
  children: ReactNode;
  loadCount: number;
  hideSeeAllButton: boolean;
};
const OFFSET_TOP = 371;

const LoadMore = ({ children, loadCount, hideSeeAllButton }: LoadMoreProps) => {
  const styles = useStyles();
  const containerRef = useRef<HTMLDivElement>(null);
  const [loadedCount, setLoadedCount] = useState(loadCount);
  const [numberOfClicks, setNumberOfClicks] = useState(1);
  const [shouldScroll, setShouldScroll] = useState(false);
  const currentSelectedFont = useStore((state) => state.currentSelectedFont);
  const scrollToSelectedFont = useStore((state) => state.scrollToSelectedFont);
  const setScrollToSelectedFont = useStore((state) => state.setScrollToSelectedFont);
  const childrenCount = Children.count(children);
  const loadMore = useCallback(() => {
    setLoadedCount((prev) => prev + loadCount);
    setNumberOfClicks((prev) => prev + 1);
    analytics.moreFontsLoaded(String(numberOfClicks));
  }, [numberOfClicks]);
  const showLoadMoreButton = childrenCount > loadedCount;

  useEffect(() => {
    if (scrollToSelectedFont) {
      setLoadedCount(childrenCount);
      setScrollToSelectedFont(false);
      setShouldScroll(true);
    }
  }, [scrollToSelectedFont]);

  useEffect(() => {
    if (shouldScroll) {
      const elem = containerRef.current.querySelector(`#${getFontId(currentSelectedFont)}`);
      const position = getPositionOffset(elem) - OFFSET_TOP;

      window.scrollTo({ left: 0, top: position, behavior: 'smooth' });
      console.log('xxx', getFontId(currentSelectedFont), currentSelectedFont);
      setShouldScroll(false);
    }
  }, [shouldScroll]);

  return (
    <>
      <div className={styles.list} ref={containerRef}>
        {Children.toArray(children)
          .slice(0, loadedCount)
          .map((child) => child)}
      </div>

      {showLoadMoreButton ? (
        <div className={styles.btnContainer}>
          <Button className={styles.button} size={ButtonSizeXL} onClick={loadMore}>
            Load More Fonts
          </Button>
        </div>
      ) : (
        !hideSeeAllButton && <SeeAllFonts />
      )}
    </>
  );
};

export default LoadMore;
